<div class="app-body">
    <div class="row">
        <div class="col-xxl-12">
            <div class="card" style="margin-left: 1px;">
                <div class="card-body">
                    <div class="custom-tabs-container">
                        <ul class="nav nav-tabs justify-content-end" id="customTab5" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="tab-Report" data-bs-toggle="tab" href="#Report"
                                    role="tab" aria-controls="Report" aria-selected="true">
                                    <span class="badge bg-info" style="font-size: 16px;">Gửi Push Notification</span>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content" id="customTabContent">
                            <div class="tab-pane fade show active" id="Report" role="tabpanel">
                                <div class="row gx-4">
                                    <div class="col-lg-12 col-sm-12 col-12">
                                        <label class="form-label">Tiêu đề</label>
                                        <input [(ngModel)]="ThanhVienThietBiService.BaseParameter.Name" placeholder="Nhập tiêu đề ..."
                                            class="form-control">
                                    </div>
                                    <div class="col-lg-12 col-sm-12 col-12">
                                        <label class="form-label">Nội dung</label>
                                        <input [(ngModel)]="ThanhVienThietBiService.BaseParameter.Description" placeholder="Nhập nội dung ..."
                                            class="form-control">
                                    </div>
                                    <div class="col-lg-12 col-sm-12 col-12">
                                        <label class="form-label">Hình ảnh</label>
                                        <input [(ngModel)]="ThanhVienThietBiService.BaseParameter.FileName" placeholder="Nhập link hình ..."
                                            class="form-control">
                                    </div>
                                    <div class="col-lg-12 col-sm-12 col-12">
                                        <a style="width: 100%;" class="btn btn-success" title="Tìm"
                                            (click)="PushNotification()"><i
                                                class="bi bi-send"></i></a>&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                                <div class="row gx-4">
                                    <div class="col-lg-11 col-sm-12 col-12">
                                        <input [(ngModel)]="ReportService.BaseParameter.SearchString" placeholder="Tìm ..."
                                            class="form-control" (keyup.enter)="ReportSearch()">
                                    </div>
                                    <div class="col-lg-1 col-sm-12 col-12">
                                        <a style="width: 100%;" class="btn btn-success" title="Tìm"
                                            (click)="ReportSearch()"><i
                                                class="bi bi-search"></i></a>&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                                <div class="card mb-4 card-info">
                                    <div class="card-header">
                                        <h5 class="card-title text-white">Danh sách
                                            <span *ngIf="ReportService.List">({{ReportService.List.length}}
                                                items)</span>
                                        </h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="table-outer">
                                            <div class="table-responsive">
                                                <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                                    #ReportSort="matSort"
                                                    [dataSource]="ReportService.DataSource"
                                                    class="table table-striped m-0">
                                                    <ng-container matColumnDef="STT">
                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                            STT
                                                        </th>
                                                        <td mat-cell *matCellDef="let element; index as i;"
                                                            style="text-align: center;">
                                                            <div *ngIf="ReportPaginator">
                                                                {{ReportPaginator.pageSize *
                                                                ReportPaginator.pageIndex + i + 1}}
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="PushNotificationTieuDe">
                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tiêu đề
                                                        </th>
                                                        <td mat-cell *matCellDef="let element">
                                                            
                                                            <a style="cursor: pointer;" title="{{element.PushNotificationTieuDe}}"
                                                                    class="link-primary"
                                                                    (click)="ThanhVienLichSuThongBaoView(element.PushNotificationTypeName)"><b>{{element.PushNotificationTieuDe}}</b></a>
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="PushNotificationNoiDung">
                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nội dung</th>
                                                        <td mat-cell *matCellDef="let element">
                                                            {{element.PushNotificationNoiDung}}
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="PushNotificationTongTinDaGui">
                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tổng tin nhắn đã gửi
                                                        </th>
                                                        <td mat-cell *matCellDef="let element">
                                                            {{element.PushNotificationTongTinDaGui}}
                                                        </td>
                                                    </ng-container>
                                                    <ng-container matColumnDef="PushNotificationTongTinDaNhan">
                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tổng tin đã nhận 
                                                        </th>
                                                        <td mat-cell *matCellDef="let element">
                                                            {{element.PushNotificationTongTinDaNhan}}
                                                        </td>
                                                    </ng-container>
                                                    <tr mat-header-row
                                                        *matHeaderRowDef="ReportService.DisplayColumnsPushNotification0000001">
                                                    </tr>
                                                    <tr mat-row
                                                        *matRowDef="let row; columns: ReportService.DisplayColumnsPushNotification0000001;">
                                                    </tr>
                                                </table>
                                                <mat-paginator *ngIf="!NotificationService.IsMobile"
                                                    #ReportPaginator="matPaginator"
                                                    [pageSizeOptions]="[10,20,50,100]" [pageSize]="6"
                                                    [showFirstLastButtons]></mat-paginator>

                                                <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                                    #ReportSort="matSort"
                                                    [dataSource]="ReportService.DataSource"
                                                    class="table table-striped m-0">
                                                    <ng-container matColumnDef="STT">
                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                            Danh sách
                                                        </th>
                                                        <td mat-cell *matCellDef="let element; index as i;">
                                                            <div class="row gx-4">
                                                                <div class="col-lg-12 col-sm-12 col-12">
                                                                    <label class="form-label">STT</label>
                                                                    <div *ngIf="ReportPaginator">
                                                                        {{ReportPaginator.pageSize *
                                                                        ReportPaginator.pageIndex + i + 1}}
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-sm-12 col-12">
                                                                    <label class="form-label">Tiêu đề</label>
                                                                        {{element.PushNotificationTieuDe}}
                                                                </div>
                                                                <div class="col-lg-12 col-sm-12 col-12">
                                                                    <label class="form-label">Nội dung</label>
                                                                        {{element.PushNotificationNoiDung}}
                                                                </div>
                                                                <div class="col-lg-12 col-sm-12 col-12">
                                                                    <label class="form-label">Tổng tin nhắn đã gửi</label>
                                                                        {{element.PushNotificationTongTinDaGui}}
                                                                </div>
                                                                <div class="col-lg-12 col-sm-12 col-12">
                                                                    <label class="form-label">Tổng tin đã nhận</label>
                                                                    {{element.PushNotificationTongTinDaNhan}}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <tr mat-header-row
                                                        *matHeaderRowDef="ReportService.DisplayColumnsPushNotification0000001Mobile">
                                                    </tr>
                                                    <tr mat-row
                                                        *matRowDef="let row; columns: ReportService.DisplayColumnsPushNotification0000001Mobile;">
                                                    </tr>
                                                </table>
                                                <mat-paginator *ngIf="NotificationService.IsMobile"
                                                    #ReportPaginator="matPaginator"
                                                    [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                                    [showFirstLastButtons]></mat-paginator>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="ReportService.IsShowLoading"></app-loading>